import * as types from '../actions/types'

const initialMerchant = {
  name: '',
  code: '',
}

const initalLoading = {
  isLoading: true,
}

const merchant = (state = initialMerchant, action) => {
  switch (action.type) {
    case types.RECEIVE_INITIAL_STATE_SUCCESS:
      return action.merchant
    case types.UPDATE_MERCHANT:
      return action.merchant
    default:
      return state
  }
}

export const LoadingMerchant = (state = initalLoading, action) => {
  switch (action.type) {
    case types.LOADING_MERCHANT:
      return {
        isLoading: action.isLoading,
      }
    default:
      return state
  }
}

export default merchant
